export default function getErrorStatus(error: unknown): number | null {
  if (typeof error === 'object' && error !== null) {
    if ('status' in error && typeof error.status === 'number') {
      return error.status;
    }
    if ('error' in error && typeof error.error === 'object' && error.error !== null) {
      if ('status' in error.error && typeof error.error.status === 'number') {
        return error.error.status;
      }
    }
  }
  return null;
}
